import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmCheck, IconLlmOptions } from '@websolutespa/bom-mixer-icons';
import { LlmContext, useLlm } from '../../../useLlm/useLlm';
import style from './page-context.module.scss';

export const PageContext: React.FC = () => {
  const label = useLabel();
  const contexts = useLlm(state => state.contexts);
  const currentContext = useLlm(state => state.currentContext);
  const { setCurrentContext } = useLlm(state => state.actions);
  const hasContexts = contexts && contexts.length > 1;
  const onSelect = (context: LlmContext) => {
    setCurrentContext(context);
  };
  return hasContexts && (
    <Ariakit.MenuProvider>
      <Ariakit.MenuButton render={(
        <button type="button" className={getClassNames(style.options)}
          aria-label={label('llm.tone')}
        >
          <IconLlmOptions />
        </button>
      )} />
      <Ariakit.Menu portal className={getClassNames(style.context)}>
        <Ariakit.MenuHeading className={getClassNames(style.title)}>Chi sei?</Ariakit.MenuHeading>
        <Ariakit.MenuGroup className={getClassNames(style.items)}>
          {contexts.map((context, i) => (
            <Ariakit.MenuItem
              key={`context-${i}`}
              className={getClassNames(style.item)}
              data-active-item={context === currentContext}
              onClick={() => onSelect(context)}
            >
              {context.title} {context === currentContext && (
                <IconLlmCheck />
              )}
            </Ariakit.MenuItem>
          ))}
        </Ariakit.MenuGroup>
      </Ariakit.Menu>
    </Ariakit.MenuProvider>
  );
};
